import React from 'react';
import { Spin, SpinProps } from 'antd';
import styled from 'styled-components';

export interface ICentredSpinnerComponentProps extends SpinProps {
    className?: string;
}

const CentredSpinner = ({
    className,
    ...props
}: ICentredSpinnerComponentProps) => {
    return (
        <SpinnerContainer className={className}>
            <Spin size="large" {...props} />
        </SpinnerContainer>
    );
};

const SpinnerContainer = styled.div`
    left: 50%;
    position: fixed;
    top: 50%;
`;

export default CentredSpinner;
